export default __webpack_public_path__ + "static/media/madame_detail20.4099b984.jpg";